var map = {
	"./3dmodel.svg": "ea5f",
	"./3dmodel_active.svg": "0205",
	"./BKHole.svg": "366c",
	"./avatar.svg": "f2e9",
	"./book-close.svg": "379d",
	"./book-close_active.svg": "ef77",
	"./close.svg": "8b1b",
	"./computer.svg": "77a9",
	"./computer_active.svg": "3d12",
	"./discord.svg": "e3a3",
	"./earth.svg": "6615",
	"./facebook-f.svg": "99fe",
	"./folder.svg": "383d",
	"./folder_active.svg": "ae3b",
	"./google.svg": "d950",
	"./house.svg": "750c",
	"./image.svg": "931c",
	"./image_active.svg": "cdc2",
	"./instagram.svg": "bd6c",
	"./ipfs.svg": "c3d7",
	"./ipfs_active.svg": "7dc4",
	"./line.svg": "aa4c",
	"./logo.svg": "5b1c",
	"./logo_white.svg": "6250",
	"./logout.svg": "69e3",
	"./map/dot_add.svg": "d00c",
	"./map/dot_add_key.svg": "7b89",
	"./map/icon_IPFS_outlined.svg": "e212",
	"./map/icon_IPFS_outlined_w.svg": "2137",
	"./map/icon_box_outlined.svg": "7d89",
	"./map/icon_box_outlined_w.svg": "fef2",
	"./map/icon_cross_w.svg": "272b",
	"./map/icon_facebook.svg": "0d60",
	"./map/icon_instagram.svg": "9b12",
	"./map/icon_note_outlined.svg": "3ea5",
	"./map/icon_note_outlined_w.svg": "2c40",
	"./map/icon_photo_outlined.svg": "c173",
	"./map/icon_photo_outlined_w.svg": "6eb9",
	"./map/icon_pod_outlined.svg": "0467",
	"./map/icon_pod_outlined_w.svg": "caf4",
	"./map/icon_post_outlined.svg": "716c",
	"./map/icon_post_outlined_w.svg": "8f0b",
	"./map/icon_stage_outlined.svg": "bade",
	"./map/icon_stage_outlined_w.svg": "fe29",
	"./map/icon_video_outlined.svg": "d430",
	"./map/icon_video_outlined_w.svg": "d22b",
	"./map/icon_webpage_outlined.svg": "798c",
	"./map/icon_webpage_outlined_w.svg": "044d",
	"./map/icon_youtube.svg": "5254",
	"./map/icon_youtube_outlined.svg": "c49c",
	"./map/icon_youtube_outlined_w.svg": "1bd7",
	"./money.svg": "cf44",
	"./payment.svg": "4f6e",
	"./payment_active.svg": "0ecb",
	"./setting.svg": "5de8",
	"./sound.svg": "e245",
	"./sound_active.svg": "0ed6",
	"./twitter-tile.svg": "a3a6",
	"./twitter.svg": "acf9",
	"./video.svg": "512b",
	"./video_active.svg": "c397",
	"./virsody-logo-footer.svg": "4f2f",
	"./web.svg": "72d5",
	"./web_active.svg": "d2c5",
	"./website.svg": "7824",
	"./website_active.svg": "a35d",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cff";